import { tween, styler } from 'popmotion';

export function animateOldContainer(oldContainer) {
    return new Promise((resolve) => {
        tween({ from: 1, to: 0, duration: 300 })
            .start({
                update: (val) => {
                    styler(oldContainer).set('opacity', val);
                },
                complete: resolve,
            });

    });
}

export function animateNewContainer(newContainer) {
    return new Promise((resolve) => {
        const body = document.getElementsByTagName('body')[0];
        const main = document.getElementsByClassName('mainWrap')[0];

        body.setAttribute('data-namespace', main.getAttribute('data-namespace'));

        tween({ from: 0, to: 1, duration: 300 })
            .start({
                update: (val) => {
                    styler(newContainer).set('opacity', val);
                },
                complete: resolve,
            });
    });
}



// WEBPACK FOOTER //
// ./resources/assets/js/transitions/timeline.js